module.exports = __webpack_public_path__ + "img/cross-small.abd37dec.svg";